import './Intro.css';


const Intro = () => {

  return (

    <h6 className='introText'>Who is your 🍁 Hero?  Add a HERO card into this awesome site ➥</h6>
  );
}

export default Intro;